import Phone from '@mui/icons-material/Phone';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import React from 'react';
import { useSelector } from 'react-redux';
import { AppState, franchiseSelector } from '../../common/store/store';

export const HomeContactTel = () => {
    const franchise = useSelector((state: AppState) => franchiseSelector.selectById(state, state.device.currFranchise));

    const [tel, setTel] = React.useState(franchise?.tel ?? '(514) 497-5636');

    const sendCliqueSurTelephone = () => {

        (window as any)['gtag']('event', 'conversion_event_contact');

    };

    React.useEffect(() => {
        setTel(franchise?.tel ?? '(514) 497-5636');
    }, [franchise]);
    return <Container sx={{ textAlign: 'center' }}>

        <Box sx={{ textAlign: 'center', }}>
            <Box component={'img'} sx={{ m: 1, height: 55 }} src="/images/CWB_Logo.png" title="Logo certification CWB" />
            <Box component={'img'} sx={{ m: 1, mb: 2, height: 40 }} src="/images/CNESST_logo.png" title="Logo CNESST" />
            <Box component={'img'} sx={{ m: 1, mb: 2, height: 40 }} src="/images/RBQ_logo.png" title="Logo Régie du bâtiment du Québec" />
        </Box>
        <Typography>Les Pieux Protech Inc., une entreprise <strong className='white'>certifiée</strong>.</Typography>
        <Typography variant='h1' sx={{ pt: 1, pb: 3 }}>
            <a onClick={sendCliqueSurTelephone} className='telheader' href={'tel:' + tel}><Phone /> {tel}</a>
        </Typography>
    </Container>;
};
